import { API_ENDPOINT } from "../constants";
import { HTTP } from "./http";

export const AccountService = {
  save: (
    data: {
      name: string,
      plan: string,
      type_plan: string,
      admin: {
        name: string,
        email: string,
      },
      _id?: string,
    }
  ) => {
    return HTTP.post<any, any>(`${API_ENDPOINT}accounts`, data);
  },
  update: (
    data: {
      name: string,
      plan: string,
      type_plan: string,
      _id?: string,
    }
  ) => {
    return HTTP.post<any, any>(`${API_ENDPOINT}accounts/update`, data);
  },
  list: () => {
    return HTTP.get<any, any>(`${API_ENDPOINT}accounts`);
  },
  setStatus: (_id: string, status: boolean) => {
    return HTTP.post<any, any>(`${API_ENDPOINT}accounts/set-status`, { _id, status });
  },
  // saveField: (
  //   customer: string,
  //   name: string,
  //   _id?: string,
  //   hectares?: string,
  //   status?: boolean
  // ) => {
  //   return HTTP.post<any, any>(`${API_ENDPOINT}customers/field`, { _id, customer, name, hectares, status });
  // },
  // fields: (customer: string) => {
  //   return HTTP.get<any, any>(`${API_ENDPOINT}customers/field/${customer}`);
  // },
}